<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1100px"
      :show-save-button="false"
      title="加工单列表"
      id-key="PurchaseDemandId"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
    >
      <list
        ref="list"
        row-key="PurchaseDemandId"
        :page="page"
        :show-query="true"
        :get-data-func="api[func]"
        @getDataEnd="getDataEnd"
        show-checkbox
        :query-params="params"
        @reset="$refs.picker.clear()"
        @check-change="checkChange"
      >
        <template slot="query">
          <el-form-item label-width="100px" label="工单时间" >
            <range-picker
              ref="picker"
              @change="
                (x) => {
                  params.DocDateStart = x.Start;
                  params.DocDateEnd = x.End;
                }
              "
              style="min-width:260px"
            >
            </range-picker>
          </el-form-item>
          <el-form-item label-width="100px" label="工单编码" >
            <el-input
              class="Text"
              clearable
              v-model="params.DocNo"
              placeholder="工单编码"
            
            />
          </el-form-item>
          <!-- <el-form-item label-width="100px" label="委外商" >
            <el-input
              clearable
              v-model="params.TradeUnitName"
              placeholder="委外商"
             class="Text"
            />
          </el-form-item> -->
          <el-form-item label-width="100px" label="存货名称" >
            <el-input
              clearable
              v-model="params.ProductName"
              placeholder="存货名称"
              class="Text"
            />
          </el-form-item>
          <el-form-item
            label-width="180px"
            label="是否包含执行过的加工单"
            prop="StocksCode"
          >
            <el-select v-model="params.IsExecute" class="IsExecute">
              <el-option
                v-for="item in [
                  {
                    id: 0,
                    label: '否',
                    value: false,
                  },
                  {
                    id: 1,
                    label: '是',
                    value: true,
                  },
                ]"
                :key="item.id"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </template>

        <el-tabs v-model="activeName" type="card" slot="tabs" @tab-click="tabClick">
          <el-tab-pane label="明细" name="tab1"></el-tab-pane>
          <el-tab-pane label="按照名称汇总" name="tab2"></el-tab-pane>
        </el-tabs>

        <template slot="table">
          <el-table-column
            prop="DocDate"
            label="加工单时间"
            min-width="120"
            align="left"
            key="key1"
            v-if="activeName === 'tab1'"
          >
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.DocDate)}}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="WorkDocNo"
            label="加工单编码"
            min-width="120"
            align="left"
            key="key2"
            v-if="activeName === 'tab1'"
          ></el-table-column>
          <el-table-column
            prop="ProductName"
            label="存货名称"
            min-width="120"
            align="left"
            key="key3"
          ></el-table-column>
          <el-table-column
            prop="ColorName"
            label="颜色"
            min-width="100"
            align="left"
            key="key5"
          ></el-table-column>
          <el-table-column
            prop="PropertyName"
            label="属性"
            min-width="120"
            align="left"
            key="key6"
          ></el-table-column>
          <el-table-column
            prop="ActualQuantity"
            label="数量"
            min-width="120"
            align="right"
            key="key4"
            v-if="activeName === 'tab1'"
          >
            <template slot-scope="{row}">
              <span>{{$commonJs.toThousands(row.ActualQuantity)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="QuantitySum"
            label="数量"
            min-width="120"
            align="right"
            key="key4"
            v-if="activeName === 'tab2'"
          >
          <template slot-scope="{row}">
            <span>{{$commonJs.toThousands(row.QuantitySum)}}</span>
          </template>
        </el-table-column>
        </template>
      </list>

      <template slot="footer">
        <el-button type="primary" @click="save">确定</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import listMixin from "@/mixins/list";
import commonDialog from "@/components/common/dialog";
import list from "@/components/common/list";

export default {
  mixins: [editDialogMixin, listMixin],
  components: {
    commonDialog,
    list,
  },
  data() {
    return {
      api: require("@/api/pu/puPurchaseDemand").default,
      params: {
        DocNo: "",
        DocDateStart: "",
        DocDateEnd: "",
        ProductName: "",
        TradeUnitName: "",
        IsExecute: false,
        ProcessStage: 0,
        ShowAll:false,
        OrderType:25
      },
      activeName: 'tab1',
      checkList: [],
      workDocListData: null,
      workDocSummaryData: null,
      func: 'workDocList',
    };
  },
  methods: {
    getDataEnd(data){
      console.log('data====', data)
      if(this.activeName === 'tab1'){
        this.workDocListData = data;
       
      }
      if(this.activeName === 'tab2'){
        this.workDocSummaryData = data;
      }
    },
    tabClick({index}){
      if(index === '0'){
        this.func = 'workDocList';
        this.$nextTick(() => {          
            this.$refs.list.getData({OrderType:25})
          })
        
      }

      if(index === '1'){
        this.func = 'workDocSummary';
        this.$nextTick(() => {
            this.$refs.list.getData({OrderType:25})
        })
      }
      console.log('index', index)
    },
    save() {
      this.$emit("saved", {list: this.checkList, type: this.activeName});
      this.close();
    },
    onCreateOpened() {
     //this.params={IsExecute: false};
      this.$refs.list.getData(this.params);
    },
    checkChange(data) {
      this.checkList = data;
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .Text  .el-input__inner{
  width: 260px!important;
}
/deep/ .IsExecute .el-input .el-input__inner{
  width: 160px;
}
</style>